module.exports = __webpack_public_path__ + "static/media/日历11@2x.16882dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历11@2x.png
// module id = 1383
// module chunks = 0